import { useTranslation } from 'react-i18next';
import { useDebounceCallback } from './debounce';

export function useLanguageChanged(callback: () => void, options?: { callOnInit?: boolean, timeoutMs?: number }) {
  const { timeoutMs = 300, callOnInit = false } = options ?? {};
  const { i18n } = useTranslation();
  const language = i18n.isInitialized ? i18n.language : undefined;
  useDebounceCallback(language, { callback: callback, callOnInit, timeoutMs });
}
